import type { SiteEntity } from '../../types/site';
import type { ProjectIntent } from '../../types/siteRag';
import type { ReportTypeId } from '../../config/reportTypes';
import { deriveIntentForSelectedAssessment } from '../generationImpact/selectedAssessmentIntent';
import { intentCriticalScope } from '../overview/computeOverviewFindingCards';
import { orderAnalysesByGoSequence, requiredAnalysesForGo } from './mandatoryReports';
import { resolveAnalysisApplicability } from './analysisApplicability';

/** One deterministic applicability plan for Path to GO and its document run.
 * It grants no report/evidence authority: current selected planning, independent
 * Intent constraints and existing analysis setup policies remain canonical. */
export function resolvePathToGoPlannedTypes(site: SiteEntity, intent: ProjectIntent | undefined = site.projectIntent): {
  requiredTypes: ReportTypeId[]; scopeTypes: ReportTypeId[]; plannedTypes: ReportTypeId[];
} {
  const activeIntent = deriveIntentForSelectedAssessment(intent, site.generationAssessmentSelection);
  const requiredTypes = requiredAnalysesForGo(activeIntent, site.typedPreferencesDefaults?.['power-availability'], site);
  const { reportTypes: broadScopeTypes } = activeIntent ? intentCriticalScope(activeIntent) : { reportTypes: requiredTypes };
  const scopeTypes = [...new Set<ReportTypeId>([...broadScopeTypes, 'financial', 'supply-chain-risk'])].filter(type =>
    resolveAnalysisApplicability({ type, site, requiredTypes, scopeTypes: broadScopeTypes,
      ...(site.generationAssessmentSelection?.kind === 'grid-led-standby-planning' ? { intent: activeIntent } : {}) }).role === 'intent-relevant');
  return { requiredTypes, scopeTypes, plannedTypes: orderAnalysesByGoSequence([...new Set<ReportTypeId>([...requiredTypes, ...scopeTypes])]) };
}
